<ng-container *transloco="let convert;">
  @for (bannerAlert of bannerAlerts; track bannerAlert) {
    <div class="row m-0 p-2 d-flex align-items-center">
      @switch (bannerAlert.type) {
        @case ('ARBITRATION_CASE') {
          <ng-container
            [ngTemplateOutlet]="arbitrationCase"
            [ngTemplateOutletContext]="{bannerAlert: bannerAlert}"
          ></ng-container>
        }
      }
    </div>
  }


  <ng-template let-bannerAlert="bannerAlert" #arbitrationCase>
    @if (bannerAlert.alertContent.status === 'OPEN') {
      <div class="ps-0 d-flex align-items-center">
        <em class='warning-icon'></em>
        <span>
          <a
            allytm-click-tagged='true'
            class= "text-primary fw-bold"
            routerLink=".{{bannerAlert.alertContent.link}}"
            [state]="{ scrollPosition: scrollPosition }"
            (click)="handleArbitrationClick(bannerAlert)"
            target="_self"
            data-test-id="app-open-arbitration-banner-e-arbitration-link"
            [innerHTML]="convert('auctionSummary.auctionSummaryResultItemBanner.textArbitrationCase', {bannerAlert : bannerAlert.alertContent.claimNumber})"
            >
          </a> {{convert('auctionSummary.auctionSummaryResultItemBanner.textUnderReview')}}
        </span>
      </div>
    }
  </ng-template>
</ng-container>
